import { MOVIE } from '../constants/itemTypes'
import getMomentTomorrow from './getMomentTomorrow';
import getMomentDateObj from './getMomentDateObj';
import setMomentDateObjZero from './setMomentDateObjZero';
import getMomentNow from './getMomentNow';
import getFirstCurrentPerformanceByTime from './getFirstCurrentPerformanceByTime';


const filterMoviesToday = (collectionItems, movies, nowObject, timezone, filterValue) => {
    const todayObject = nowObject.clone().subtract(1, 'hours')
    const nowMoment = getMomentNow(timezone)
    const tomorrowObject = setMomentDateObjZero(getMomentTomorrow(nowObject))
    
    let items = []
    
    collectionItems.map(item => {
        const { id, type } = item
        
        if(MOVIE === type) {
            const movie = movies[id]
            const { performances } = movie 
            const isTopical = performances.find(({timeUtc}) => {
                const performanceDate = getMomentDateObj(timeUtc, timezone)
                return nowMoment.isSameOrBefore(performanceDate) && performanceDate.isBefore(tomorrowObject)
            })
            
            if(isTopical) {
                items.push(item)
            }
        }
    })
    
    if('moviesTodayByStart' === filterValue) {
        items.sort(function(a, b) {
            const movieA = a.type === MOVIE ? movies[a.id] : null
            const movieB = b.type === MOVIE ? movies[b.id] : null
            
            const firstPerfA = getFirstCurrentPerformanceByTime(nowMoment, movieA.performances, timezone)
            const firstPerfB = getFirstCurrentPerformanceByTime(nowMoment, movieB.performances, timezone)

            const aUtc = firstPerfA ? firstPerfA.timeUtc : null
            const bUtc = firstPerfB ? firstPerfB.timeUtc : null
    
            return bUtc > aUtc ? -1 : bUtc < aUtc ? 1 : 0
        })

    }

    return items
}

export default filterMoviesToday